import { Alert, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PageContainer } from "../../components/primitives/layout/PageContainer";
import { LoadingTitle } from "../../components/primitives/data-display/LoadingTitle";
import { LoadingStage } from "../../components/domain/feedback/LoadingStage";
import { BackButton } from "../../components/domain/navigation/BackButton";
import { ErrorState } from "../../components/domain/feedback/ErrorState";
import { gaps } from "../../components/primitives/spacing";
import { useFetching } from "./useFetching";
import { ROUTES } from "../../route_paths";

/**
 * Loading screen shown after submission. Fires extraction + verification on mount and navigates
 * to the result, or /review when the claim is ambiguous.
 */
export default function Fetching() {
  const { apiError, rateLimitError, activeStepIndex, subMessage, steps } = useFetching();
  const { t } = useTranslation();

  const minutes = rateLimitError ? Math.max(1, Math.ceil(rateLimitError.retryAfter / 60)) : 0;

  return (
    <PageContainer center>
      {rateLimitError ? (
        <Stack gap={gaps.base} sx={{ width: "100%" }}>
          <Alert severity="info">{t("rateLimit.message", { count: minutes })}</Alert>
          <BackButton to={ROUTES.landing.path()} label={t("common.startOver")} />
        </Stack>
      ) : apiError ? (
        <ErrorState
          code={apiError.code}
          action={<BackButton to={ROUTES.landing.path()} label={t("fetching.tryAgain")} />}
        />
      ) : (
        <>
          <LoadingTitle>{t("fetching.title")}</LoadingTitle>
          <LoadingStage steps={steps} activeStepIndex={activeStepIndex} subMessage={subMessage} />
        </>
      )}
    </PageContainer>
  );
}
